import { pr, React, theme } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { ui } from "components/util/uiHelpers";
import { ConsentStatus, IConsentsResponse } from "types/usermanagement";
import { ThirdPartyPortrait } from "./TPPMember";

function statusToString(status: ConsentStatus) {
    switch (status) {
        case "received":
            return ui.__("tpp.status.received");
        case "rejected":
            return ui.__("tpp.status.rejected");
        case "partiallyAuthorised":
            return ui.__("tpp.status.partiallyAuthorised");
        case "valid":
            return ui.__("tpp.status.valid");
        case "revokedByPsu":
            return ui.__("tpp.status.revokedByPsu");
        case "expired":
            return ui.__("tpp.status.expired");
        case "terminatedByTpp":
            return ui.__("tpp.status.terminatedByTpp");
        default:
            return "-";
    }
}

export const TPP = ({
    onClick,
    hasDetails,
    consent,
    separator,
}: {
    onClick?: () => void;
    hasDetails?: boolean;
    consent: IConsentsResponse;
    separator?: boolean;
}) => {
    const explicitConsent = consent.consents.length > 0 ? consent.consents[0] : null;

    return (
        <div>
            <pr.HFlex
                style={{
                    paddingTop: theme.MARGIN,
                    paddingBottom: theme.MARGIN,
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <div style={{ marginRight: theme.MARGIN_SMALL }}>
                    <ThirdPartyPortrait />
                </div>
                <pr.HFlexCentered style={{ flex: 1 }}>
                    <div style={{ flex: 1 }}>
                        <pr.P_16_TITLE
                            style={{
                                color: ui.isDarkMode ? "white" : "#0A285C",
                                fontWeight: 600,
                                lineHeight: "24px",
                                marginBottom: explicitConsent?.grantDate || explicitConsent?.validUntil || explicitConsent?.consentStatus
                                    ? 16
                                    : undefined
                            }}
                        >
                            {consent.organizationName}
                        </pr.P_16_TITLE>
                        {explicitConsent?.grantDate &&
                            <pr.P_16_CONTENT>
                                {ui.__("tpp.validFrom")} {explicitConsent.grantDate}
                            </pr.P_16_CONTENT>
                        }
                        {explicitConsent?.validUntil &&
                            <pr.P_16_CONTENT>
                                {ui.__("tpp.validUntil")} {explicitConsent.validUntil}
                            </pr.P_16_CONTENT>
                        }
                        {explicitConsent?.consentStatus &&
                            <pr.P_16_CONTENT>
                                {ui.__("tpp.status")} {statusToString(explicitConsent.consentStatus)}
                            </pr.P_16_CONTENT>
                        }
                    </div>
                </pr.HFlexCentered>
                {hasDetails && (
                    <GdsFakeActionButton onClick={onClick}>
                        {ui.__("tpp.button.details")}
                    </GdsFakeActionButton>
                )}
            </pr.HFlex>
            {separator && <pr.LightSeparatorLine />}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/tpp/TPP.tsx